import React from 'react';

/**
 * Reusable form section component with consistent styling
 * 
 * @param {Object} props
 * @param {string} props.title - Section title
 * @param {React.ReactNode} props.children - Form fields
 * @param {string} props.color - Accent color (default: blue)
 */
const FormSection = ({ title, children, color = "blue" }) => {
  const colorMap = {
    blue: "bg-blue-500",
    green: "bg-green-500",
    orange: "bg-orange-500", 
    purple: "bg-purple-600",
    red: "bg-red-500"
  };

  const accentColor = colorMap[color] || colorMap.blue;

  return (
    <div className="mb-8">
      <h2 className="text-lg font-bold mb-4 flex items-center">
        <span className={`w-2 h-6 ${accentColor} rounded-sm mr-2`}></span>
        {title}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {children}
      </div>
    </div>
  );
};

export default FormSection;